export default "__VITE_ASSET__966fd2a0__"